const PUBLIC_API_ENDPOINT = process.env.REACT_APP_PUBLIC_API_ENDPOINT;
const PUBLIC_PRIVATE_TEST_CODE = process.env.REACT_APP_PUBLIC_PRIVATE_TEST_CODE;
const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
const PUBLIC_ENDPOINT = process.env.REACT_APP_PUBLIC_ENDPOINT;

export { PUBLIC_PRIVATE_TEST_CODE, GA_MEASUREMENT_ID, PUBLIC_API_ENDPOINT, PUBLIC_ENDPOINT };
